<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      COPYRIGHT © {{ new Date().getFullYear() }}
      <b-link class="ml-25" href="#" target="_blank">M/s. Abdan & Co.</b-link>
      <span class="d-none d-sm-inline-block">, All rights Reserved</span>
      <span class="ml-25">- v{{ appVersion }}</span>
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue';

export default {
  components: {
    BLink,
  },
  computed: {
    appVersion() {
      return process.env.VUE_APP_VERSION;
    },
  },
};
</script>
